import { GuidHelper } from "@/Common/Helpers/GuidHelper";

interface ISubscription {
    (...args: any[]): void;
}

class EventEmitter {
    public showDebugInfo: boolean;
    public ServerDispatchToken: string;
    public ClientDispatchToken: string;
    public ClientDispatchTokenNote: string;
    private registry: ComponentEvent[];

    constructor() {
        this.registry = [];
        this.showDebugInfo = false;
    }

    public AddListener(name: string, fn: ISubscription, context: React.Component<any, any>, debugName: string): string {
        var c = ComponentEvent.Create(name, fn, context, debugName);
        this.registry.push(c);
        return c.id;
    }

    public RemoveListener(id: string): void {
        this.removeEvent(id);
    }

    public Clear(): void {
        this.registry.length = 0;
    }

    public Emit(name: string, ...args: any[]): void {
        var events = this.registry.filter(i => i.name === name);
        for (let current of events) {
            try {
                current.fn.apply(current.context, args);
            }
            catch (e) {
                if (this.showDebugInfo) {
                    console.log("failed executing method id: " + current.id + " name: " + current.uniquename);
                    console.log("Error details: " + e);
                }
            }
        }
    }

    private removeEvent(id: string): void {
        var i = this.indexOfFunction(id);
        if (i >= 0) {
            this.registry.splice(i, 1);
        }
    }

    private indexOfFunction(id: string): number {
        var idx = -1;
        for (var i = 0; i < this.registry.length; i++) {
            if (this.registry[i].id === id)
                return i;
        }
        return idx;
    }

    public Peak(): ComponentEvent[] {
        return this.registry.filter(() => true);
    }
}

class ComponentEvent {
    public name: string;
    public uniquename: string;
    public fn: any;
    public id: string;
    public context: React.Component<any, any>;

    public static Create(name: string, func: any, context: React.Component<any, any>, debugName: string): ComponentEvent {
        var c = new ComponentEvent();
        c.name = name;
        c.uniquename = debugName;
        c.id = GuidHelper.NewGuid();
        c.fn = func;
        c.context = context;
        return c;
    }
}

export { EventEmitter };
